import { type AdminSearchRoomByLocationNameQuery } from '@exam-center/graphql';
import { type GridRowSelectionModel, NoRowsOverlay } from '@shared/components';
import { formatDateTime } from '@shared/utils';
import { useState } from 'react';

import { BaseGrantAccessRoomDataGrid } from '../../components';
import { useExamLocationGrantAccessRoomListSearchParams } from '../../hooks';

import { type AdminExamLocationManagementGrantAccessRoomListItem, columns } from './columns';

interface AdminExamLocationManagementGrantAccessRoomListProps {
  onSelectRow?: (selectedRoomId: string | undefined) => void;
  roomId?: string;
  adminSearchRoomByLocationName: AdminSearchRoomByLocationNameQuery | undefined;
  loading?: boolean;
}
export default function AdminExamLocationManagementGrantAccessRoomList(
  props: Readonly<AdminExamLocationManagementGrantAccessRoomListProps>,
) {
  const { onSelectRow, roomId, adminSearchRoomByLocationName, loading } = props;
  const [selectedRoomId, setSelectedRoomId] = useState<string | undefined>(roomId);
  const [{ page, pageSize }, { changePageNumber, changePageSize }] =
    useExamLocationGrantAccessRoomListSearchParams();
  const handleRowSelectionChange = (rowSelectionModel: GridRowSelectionModel) => {
    const selectedRoomIds = rowSelectionModel as string[];
    if (selectedRoomIds.length > 0) {
      const latestRoomId = selectedRoomIds[selectedRoomIds.length - 1];
      setSelectedRoomId(latestRoomId);
      onSelectRow?.(latestRoomId);
    } else {
      setSelectedRoomId(undefined);
      onSelectRow?.(undefined);
    }
  };

  const locationRoomsData =
    adminSearchRoomByLocationName?.ecAdminSearchRoomByLocationName.rooms ?? [];
  const total = adminSearchRoomByLocationName?.ecAdminSearchRoomByLocationName.total ?? 0;
  const rows: AdminExamLocationManagementGrantAccessRoomListItem[] = locationRoomsData.map(
    (room) => ({
      id: room.id,
      province: room.building.location.province.nameTh,
      location: {
        locationName: room.building.location.nameTh,
        buildingName: room.building.nameTh,
        floorName: room.floor,
      },
      room: {
        roomName: room.name ?? undefined,
        roomNumber: room.roomNumber ?? undefined,
      },
      lastUpdatedAt: formatDateTime(room.updatedAt),
    }),
  );
  return (
    <BaseGrantAccessRoomDataGrid
      columns={columns}
      rows={rows}
      onRowSelectionModelChange={handleRowSelectionChange}
      slots={{
        noRowsOverlay: NoRowsOverlay,
      }}
      hideFooter={loading || total === 0}
      loading={loading}
      rowSelectionModel={selectedRoomId}
      slotProps={{
        footer: {
          total: total,
          pagination: {
            page: page,
            count: total,
            rowsPerPage: pageSize,
            onPageChange: (_event, page) => {
              changePageNumber(page);
            },
            onRowsPerPageChange: (event) => {
              const pageSize = parseInt(event.target.value);
              changePageNumber(0);
              return changePageSize(pageSize);
            },
          },
        },
      }}
    />
  );
}
